module.exports = __webpack_public_path__ + "img/missing_toilet_paper.a665f2bc.svg";